<template>
	<button
		v-if="allSaved"
		@click="remove(ids)"
		type="button"
		class="btn--no-style content-listing__button saved"
	>
		<svg svg-inline="" focusable="false" role="presentation" height="141.732" viewBox="-1.23 -8.789 141.732 141.732" width="141.732" xmlns="http://www.w3.org/2000/svg"><path fill="#737a85" d="M139.273 49.088c0-3.284-2.75-5.949-6.146-5.949-.219 0-.434.012-.646.031l-42.445-1.001-14.5-37.854C74.805 1.824 72.443 0 69.637 0c-2.809 0-5.168 1.824-5.902 4.315L49.232 42.169 6.789 43.17a6.606 6.606 0 0 0-.646-.031C2.75 43.136 0 45.802 0 49.088c0 2.1 1.121 3.938 2.812 4.997l33.807 23.9-12.063 37.494a5.728 5.728 0 0 0-.688 2.723c0 3.287 2.75 5.952 6.146 5.952a6.236 6.236 0 0 0 3.812-1.29l35.814-22.737 35.812 22.737a6.236 6.236 0 0 0 3.812 1.29c3.393 0 6.143-2.665 6.143-5.952 0-.979-.25-1.906-.688-2.723l-12.062-37.494 33.806-23.9c1.687-1.061 2.81-2.9 2.81-4.997"/></svg>
		<span>Remove All</span>
	</button>

	<button
		v-else
		@click="addSave(ids)"
		type="button"
		class="btn--no-style content-listing__button"
	>
		<svg svg-inline="" focusable="false" role="presentation" height="141.732" viewBox="-1.23 -8.789 141.732 141.732" width="141.732" xmlns="http://www.w3.org/2000/svg"><path fill="#737a85" d="M139.273 49.088c0-3.284-2.75-5.949-6.146-5.949-.219 0-.434.012-.646.031l-42.445-1.001-14.5-37.854C74.805 1.824 72.443 0 69.637 0c-2.809 0-5.168 1.824-5.902 4.315L49.232 42.169 6.789 43.17a6.606 6.606 0 0 0-.646-.031C2.75 43.136 0 45.802 0 49.088c0 2.1 1.121 3.938 2.812 4.997l33.807 23.9-12.063 37.494a5.728 5.728 0 0 0-.688 2.723c0 3.287 2.75 5.952 6.146 5.952a6.236 6.236 0 0 0 3.812-1.29l35.814-22.737 35.812 22.737a6.236 6.236 0 0 0 3.812 1.29c3.393 0 6.143-2.665 6.143-5.952 0-.979-.25-1.906-.688-2.723l-12.062-37.494 33.806-23.9c1.687-1.061 2.81-2.9 2.81-4.997"/></svg>
		<span>Save All</span>
	</button>
</template>

<script>
export default {
	props: ['ids', 'allSaved', 'remove', 'addSave']
};
</script>
